module.exports = __webpack_public_path__ + "static/media/avatar.74487a6c.svg";